// extracted by mini-css-extract-plugin
export default {"AboutPage":"AboutPage_AboutPage__1ALSo","container":"AboutPage_container__xt0cC","imgContainer":"AboutPage_imgContainer__TMtyS","copy":"AboutPage_copy__NjRVx"};